// extracted by mini-css-extract-plugin
export default {"container":"eP-z","title":"fP-z","link":"gP-z"};